import React from 'react';

import Footer from './../components/Footer';

const Privacy = () => (
    <main class="content">
        <h2>Privacy Policy</h2>
        <p>This page contains our privacy policy.</p>
        
        <Footer />
    </main>
);

export default Privacy;
